<template>
  <v-flex d-flex>
    <v-container fluid>
      <v-dialog v-model="dialog" max-width="290" >
        <v-card>
          <v-card-title class="headline">Cancel Summary</v-card-title>
          <v-card-text :class="dialogSuccessClass">
            <blockquote class="blockquote">
              Total orders: <b>{{totalOrders}}</b><br/>
              Order cancelled: <b>{{totalCancelledOrders}}</b><br/>
              Remaning order: <b>{{totalOrders - totalCancelledOrders}}</b>
            </blockquote>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn text color="primary" @click.stop="dialog = false" >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-fab-transition>
        <v-btn fixed bottom right dark fab color="pink" :loading="loading">
          <v-icon>cached</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-card>
        <v-card-title primary-title>
          <h2>{{$route.meta.title}}</h2>
          <div class="spacer"></div>
        </v-card-title>
        <v-layout wrap justify-space-around fill-height>
          <v-flex xs5 sm2 md4>
            <v-overflow-btn
              :items="tokens"
              v-model="token"
              label="Select a Token"
              editable
            ></v-overflow-btn>
          </v-flex>
          <v-flex xs5 sm2 md4>
            <!-- <v-overflow-btn
              :items="exchanges"
              v-model="exchange"
              label="Select a Exchange"
            ></v-overflow-btn> -->
            <!-- <v-combobox
              v-model="account"
              :items="accounts"
              :search-input.sync="search"
              hide-selected
              hint="Maximum of 5 tags"
              label="Search Exchange"
              multiple
              persistent-hint
              small-chips
              prepend-inner
            > -->
            <v-autocomplete
              v-model="account"
              :items="accounts"
              :search-input.sync="search"
              hide-selected
              hint="Maximum of 5 tags"
              label="Search Exchange"
              multiple
              persistent-hint
              small-chips
              prepend-inner
            >
               <template v-slot:no-data>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      No exchange matched
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs5 sm2 md2>
            <v-btn color="primary" style="margin-left: 40px" :loading="loading" @click="searchBot()">Search</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
      <v-card-text v-if="loading" class="elevation-1 white text-xs-center pa-3" style="transform: translateY(0px);">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-card-text>
      <v-card v-if="!loading">
        <v-layout wrap justify-space-around fill-height>
          <v-flex md6>
            <blockquote class="blockquote" style="font-size: 14px">
              Turn Off all accounts (bots) in the list (order book will be cancelled)<br/>
              [or Turn On all account (bots) in the list]
            </blockquote>
          </v-flex>
          <v-flex md6>
            <blockquote class="blockquote">
              <v-btn color="success" @click="showConfirm('TURN_ON')">Turn On</v-btn>
              <v-btn color="error" @click="showConfirm('TURN_OFF')">Turn Off</v-btn>
              <v-btn color="info" @click="showConfirm('CANCEL_BUY_ORDER')">Cancel Buy</v-btn>
              <v-btn color="info" @click="showConfirm('CANCEL_SELL_ORDER')">Cancel Sell</v-btn>
              <v-btn color="info" @click="showConfirm('CANCEL_ALL_ORDER')">Cancel All</v-btn>
            </blockquote>
          </v-flex>
        </v-layout>
      </v-card>
      <v-card v-if="!loading">
        <BotTable
          ref="botTables"
          :items="botTables"
        />
      </v-card>
    </v-container>
  </v-flex>
</template>

<script>
import MongoService from '../../services/mongo.service';
import MongoConnector from '../../services/mongo-connector.service';
import MessageDialog from '../../libs/message-dialog/';
import Alert from '../../libs/alert'
import BotTable from './BotTable'
export default {
  data() {
    const service = new MongoConnector(null, 'bot-configs', {});
    return {
      search: null,
      loading: true,
      service,
      dataReady: false,
      panel: [],
      virtualBalances: [],
      tokens: ['ALL'],
      accounts: [],
      exchanges: [],
      token: 'ALL',
      account: [],
      botTables: [],
      dialog: false,
      totalOrders: 0,
      totalCancelledOrders: 0,
      dialogSuccessClass: null
    };
  },
  async beforeMount() {
    this.loading = true
    try {
      const exchangeList = await MongoService.aggregate({
        collection: 'accounts',
        aggregate: [
          { $group: { _id: null, exchange: { $addToSet: '$exchange' } } },
          { $unwind: '$exchange' },
          { $sort: { 'exchange': 1 } },
          { $group: { _id: null, exchange: { $push: '$exchange' } } },
          { $project: { 'exchange': 1, _id: 0 } }
        ]
      })
      console.log('exchange', exchangeList[0].exchange)

      this.accounts = exchangeList[0].exchange;

      const tokenList = await MongoService.aggregate({
        collection: 'bot-configs',
        aggregate: [
          { $group: { _id: null, base_currency: { $addToSet: '$base_currency' }, quote_currency: { $addToSet: '$quote_currency' } } },
          { $project: { tokens: { $setUnion: [ '$base_currency', '$quote_currency' ] } } },
          { $addFields: { tokens: { $filter: { input: '$tokens', as: 't', cond: { $ne: ['$$t', null ] } } } } }
        ]
      })
      tokenList[0].tokens.unshift('ALL')
      console.log('tokens', tokenList[0].tokens)

      this.tokens = tokenList[0].tokens
    } catch (e) {}
    this.loading = false
  },
  async mounted () {
  },
  methods: {
    async searchBot() {
      this.loading = true
      const filter = {}
      let tokenFilter = []

      filter['$and'] = []
      if (this.token !== 'ALL') {
        tokenFilter = [ {base_currency: this.token}, {quote_currency: this.token} ]
        filter['$and'].push({ '$or': tokenFilter })
      }
      if (this.account.length > 0) {
        const accountFilter = this.account.map(a => ({
          account_id: { $regex : a.toLowerCase()}
        }))
        filter['$and'].push({ '$or': accountFilter })
      }

      if (filter['$and'].length <= 0) delete filter['$and']

      console.log('filter: ', JSON.stringify(filter))

      // const configs = await this.service.find({
      //   sort: {account_id: 1},
      //   limit: 999999, // set for no limit
      //   filter
      // });

      const configs = await MongoService.aggregate({
        collection: 'bot-configs',
        aggregate: [
          { $lookup: { from: 'accounts', localField: 'account_id', foreignField: 'account_id', as: 'accountdetails' } },
          { $match: filter },
          { $match: { accountdetails: { $ne: [] } } }
        ]
      })

      console.log('configs: ', configs)

      this.botTables = configs.map(c => ({
        _id: c._id,
        accountId: c.account_id,
        exchange: c.accountdetails[0].exchange,
        isActive: c.is_active,
        type: c.type,
        base: c.base_currency,
        quote: c.quote_currency
      }))

      this.loading = false
    },
    async showConfirm(method) {
      const selectedBots = this.$refs.botTables.$props.items
                          .filter(a => a.select === true)
      if (selectedBots.length) {
        const response = await MessageDialog.showEditConfirmMessage()
        const { value: accept } = response
        if (accept) {
          switch (method) {
            case 'TURN_ON':
              this.activateBot(true)
              break;
            case 'TURN_OFF':
              this.activateBot(false)
              break;
            case 'CANCEL_BUY_ORDER':
              this.cancelBotOrders('buy')
              break;
            case 'CANCEL_SELL_ORDER':
              this.cancelBotOrders('sell')
              break;
            case 'CANCEL_ALL_ORDER':
              this.cancelBotOrders('both')
              break;
            default:
              break;
          }
        }
      }
    },
    async activateBot(active) {
      try {
        this.loading = true
        const createBotParam = (b, isActive) => {
          return {
              _id: b._id,
              is_active: isActive
            }
        }
        const updatedBots = this.$refs.botTables.items
                            .filter(a => a.select === true)
                            .map(a => createBotParam(a, active))

        const response = await this.service.updateDocuments(updatedBots)
        this.loading = false

        await this.searchBot()

        const reselectBot = (b, selected) => {
          if (selected.some(s => s._id === b._id)) {
            b.select = true
          }
        }

        this.$refs.botTables.items.map(a => reselectBot(a, updatedBots))
      } catch (e) {
        console.error(e)
      }
    },
    async cancelBotOrders(side = 'both') {
      this.loading = true
      try {
        const selectedAccountIds = this.$refs.botTables.items
                            .filter(a => a.select === true)
                            .map(a => a.accountId)

        const res = await MongoService.botControl.cancelBotOrders(selectedAccountIds, side);

        this.totalOrders = res.length
        this.totalCancelledOrders = res.map(order => order.status === 'completed').length
        this.dialogSuccessClass = this.totalOrders === this.totalCancelledOrders ? 'green--text display-1' : 'red--text display-1'

        console.log('res: ', res)
        console.log('totalOrders: ', this.totalOrders)
        console.log('cancelledOrders: ', this.cancelledOrders)

        this.dialog = true;
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    }
  },
  components: {
    BotTable
  }
};
</script>